import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const Triangle = ({isBottom}) => { 
    return (<div className={isBottom ? "triangle bottom" : "triangle"}></div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Triangle);
